import { ArrowRight, BedDouble, ExternalLink, Ruler } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { COTTAGES } from "../../data/cottages";
import { Reveal } from "./Reveal";
import { Divider } from "./Ornaments";

export const SectionHead = ({ eyebrow, title, lead, testId, center = false }) => (
  <Reveal className={`section-head ${center ? "section-head--center" : ""}`}>
    <p className="eyebrow">{eyebrow}</p>
    <h2 className="section-title" data-testid={testId}>{title}</h2>
    <Divider />
    {lead && <p className="section-lead">{lead}</p>}
  </Reveal>
);

// A concise comparison on the homepage; full descriptions and authentic photo
// galleries remain on the individual cottage pages.
export const Cottages = () => {
  const { t, lang } = useLang();
  return (
    <section id="stugor" className="section cottages-compact" data-testid="section-stugor">
      <div className="wrap">
        <SectionHead eyebrow={t.cottages.eyebrow} title={t.cottages.title} lead={t.cottages.lead} testId="cottages-heading" center />
        <div className="cottages-compact__grid">
          {COTTAGES.map((cottage, index) => {
            const copy = t[cottage.key];
            const photo = cottage.photos[0];
            return (
              <Reveal key={cottage.key} delay={index * 80} className="cottages-compact__card">
                <a className="cottages-compact__photo" href={`/stugor/${cottage.key}`} aria-label={`${t.cottagePage.viewCottage}: ${cottage.name}`}>
                  <img src={photo.src} alt={`${cottage.name} – ${t.captions[photo.caption]}`} loading="lazy" decoding="async" />
                </a>
                <div className="cottages-compact__body">
                  <p className="script cottages-compact__tagline">{copy.tagline}</p>
                  <h3>{cottage.name}</h3>
                  <p className="cottages-compact__location">{copy.place}</p>
                  <p className="cottages-compact__intro">{copy.intro}</p>
                  <ul className="cottages-compact__facts">
                    <li><Ruler size={16} aria-hidden="true" />{copy.facts[0]}</li>
                    <li><BedDouble size={16} aria-hidden="true" />{copy.facts[1]}</li>
                  </ul>
                  <div className="cottages-compact__actions">
                    <a className="btn btn--primary" href={`/stugor/${cottage.key}`}>
                      {t.cottagePage.viewCottage}<ArrowRight size={16} aria-hidden="true" />
                    </a>
                    <a className="cottages-compact__book" href={cottage.booking[lang]} target="_blank" rel="noopener noreferrer">
                      {t.cottages.book}<ExternalLink size={15} aria-hidden="true" />
                      <span className="sr-only">({t.cottages.newTab})</span>
                    </a>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
